declare let document: any

export function getCookie(name) {
    function escape(s) {
        return s.replace(/([.*+?^$(){}|[\]/\\])/g, "\\$1")
    }
    const match = document.cookie.match(RegExp(`(?:^|;\\s*)${escape(name)}=([^;]*)`))
    return match ? match[1] : null
}

export function isNegativePin(item) {
    return Number(item.pin) <= -1 || Number(item.dataset?.pin) <= -1
}

export function hideItem(item) {
    const locItem = item
    if (locItem.style) locItem.style.display = "none"
    locItem.hidden = true
}

export function hideNegativePinnedItem(item: any) {
    const negIndex = isNegativePin(item)
    if (negIndex) hideItem(item)
}

export function reorderPinnedElements(itemsList: any) {
    // Create an same length array
    let newItemsList = Array(itemsList.length).fill(undefined)
    itemsList.forEach(item => {
        if (item && item.pin && !isNegativePin(item)) newItemsList[Number(item.pin) - 1] = item
    })
    const unpinnedItemsList = itemsList.filter(item => !item.pin || isNegativePin(item))
    // Fill unallocated(undefined) array indexes with unpinned items
    for (let i = 0; i < newItemsList.length; i += 1) {
        if (!newItemsList[i]) {
            newItemsList[i] = unpinnedItemsList.shift()
        }
    }
    newItemsList = newItemsList.filter(item => {
        return item !== undefined
    })
    return newItemsList
}

export function shufflePrimaryNav(items, cookie) {
    let newList: any = []
    if (cookie) {
        const MasIDPersonalisedNavCookieValue = cookie.split("NV1_")[1]
        const PersonalisedNavValues = MasIDPersonalisedNavCookieValue
            ? MasIDPersonalisedNavCookieValue.split("|")[0]
            : ""
        const mapped = []
        const newItemsList: any = Array.from(items)
        const orderingTags = PersonalisedNavValues?.match(/.{2}/g)
        const arr = Array(newItemsList.length)
        const itemsReferenceArray: any = Array.from(items)
        let useDefaultNav = false
        for (let i = 0; i < orderingTags?.length; i += 1) {
            if (
                !itemsReferenceArray.some(
                    item => item.mapping === orderingTags[i] || item.dataset?.mapping === orderingTags[i],
                )
            ) {
                useDefaultNav = true
                break
            }

            for (let j = 0; j < newItemsList.length; j += 1) {
                const index = newItemsList[j].pin || newItemsList[j].dataset?.pin
                if (index && Number(index) > -1) {
                    arr[index - 1] = newItemsList[j]
                    newItemsList.splice(j, 1)
                    j -= 1
                } else if (
                    newItemsList[j].dataset?.mapping === orderingTags[i] ||
                    newItemsList[j].mapping === orderingTags[i]
                ) {
                    mapped[mapped.length] = newItemsList[j] as never
                    newItemsList.splice(j, 1)
                    j -= 1
                }
            }
        }
        // If the cookie includes nav items that don't exist in the default nav, use the default nav
        if (useDefaultNav) {
            // return same elements just hide pinned ones
            items.forEach(item => {
                hideNegativePinnedItem(item)
            })
            return items
        }

        if (orderingTags?.length > 0) {
            newItemsList.forEach(item => {
                hideItem(item)
            })
        } else {
            // No MASId - hide negative pins
            newItemsList.forEach(item => {
                hideNegativePinnedItem(item)
            })
        }

        const unpinnedList = [].concat(mapped.concat(newItemsList))
        newList = Array.from(arr, (v, i) => (i in arr ? v : unpinnedList.shift())).filter(item => item)
    } else {
        // No MASId - hide negative pins
        newList = Array.from(items)
        newList.forEach(item => {
            hideNegativePinnedItem(item)
        })
    }
    return newList
}

export function getCookieAndShufflePrimaryNav(cookieString?: string) {
    let cookie
    if (cookieString) {
        cookie = cookieString
    } else {
        cookie = getCookie("MASId")
    }
    const snailTrailElement = document.getElementById("snail-trail-container")
    const childrenArray = snailTrailElement.querySelectorAll("li")
    const newList = shufflePrimaryNav(childrenArray, cookie)
    Array.from(newList).forEach(child => snailTrailElement.appendChild(child))
}

export function shufflePrimaryNavWithoutCookie() {
    const snailTrailElement = document.getElementById("snail-trail-container")
    const childrenArray = snailTrailElement.querySelectorAll("li")
    const newList = shufflePrimaryNav(childrenArray, "ID=")
    Array.from(newList).forEach(child => snailTrailElement.appendChild(child))
}

export const toString = (personalisationEnabled: boolean) => {
    const init = {
        init: personalisationEnabled ? getCookieAndShufflePrimaryNav.name : shufflePrimaryNavWithoutCookie.name,
    }
    return `
            ${getCookie.toString()}
            ${reorderPinnedElements.toString()}
            ${shufflePrimaryNav.toString()}
            ${
                personalisationEnabled
                    ? getCookieAndShufflePrimaryNav.toString()
                    : shufflePrimaryNavWithoutCookie.toString()
            }
            ${isNegativePin.toString()}
            ${hideItem.toString()}
            ${hideNegativePinnedItem.toString()}
            var personalisationEnabled = ${personalisationEnabled}
            var platmodMeganavPersInitObj = ${JSON.stringify(init)};
            var fn = window[platmodMeganavPersInitObj.init];
            if (typeof fn === "function") fn();
`
}
